import { render, staticRenderFns } from "./DxFullDataTable.vue?vue&type=template&id=c39f9554&"
import script from "./DxFullDataTable.vue?vue&type=script&lang=ts&"
export * from "./DxFullDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports